export const FETCH_WASTE_DATA = "FETCH_WASTE_DATA";
export const FETCH_WASTE_SUCCESS = "FETCH_WASTE_SUCCESS";
export const FETCH_WASTE_FAILURE = "FETCH_WASTE_FAILURE";
export const DELETE_WASTE_DATA = "DELETE_WASTE_DATA";